import { useMutation, useQuery, useQueryClient } from 'react-query';
import qs from 'qs-lite';

import api from '../../utils/api';
import { VIDEO_COMPILATION } from '../../constants/endpoints';
import { useVpSnackbar } from '../../vp-ui';

// start queries
const fetchVideoCompilations = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);

  return api.get(`${VIDEO_COMPILATION}${queryString ? `?${queryString}` : ''}`);
};
export const useFetchVideoCompilations = () => {
  const {
    limit = '25',
    offset = '0',
    orderBy = 'created_at',
    sortOrder = 'DESC'
  } = qs.parse(window?.location?.search?.split('?')?.[1]) || {};
  const queryProps = {
    limit,
    offset,
    orderBy,
    sortOrder
  };

  return useQuery([VIDEO_COMPILATION, { ...queryProps }], fetchVideoCompilations, {
    keepPreviousData: true
  });
};

const getVideoCompilationId = (id, isPublic) => {
  const pathname = window?.location?.pathname || '';
  const pathSplit = pathname.split(`${isPublic ? 'vc' : 'compilation'}/`);
  const compilationPageId = pathSplit.length > 1 ? pathSplit.pop() : null;
  return id || compilationPageId;
};

const fetchVideoCompilationById = ({ queryKey }) => {
  const compilationId = queryKey[1];
  const isShared = queryKey[2];
  return api.get(`${VIDEO_COMPILATION}/${compilationId}?share=${isShared}`);
};

export const useFetchVideoCompilationById = (props = {}) => {
  const { compilationId = '', isPublic = false, isPreview = false } = props;
  const compilationIdToUse = getVideoCompilationId(compilationId, isPublic);

  return useQuery(
    [VIDEO_COMPILATION, compilationIdToUse, !isPreview && isPublic],
    fetchVideoCompilationById,
    {
      enabled: !!compilationIdToUse
    }
  );
};

const updateVideoCompilationPage = async ({
  data,
  id,
  useToast = true,
  navigationToast = false
}) => {
  await api.put(`${VIDEO_COMPILATION}/${id}`, data);
  return { useToast, navigationToast };
};

export const useUpdateVideoCompilationPage = () => {
  const { addSnackbarSuccess, addSnackbarInfo } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(updateVideoCompilationPage, {
    onSuccess: ({ useToast, navigationToast }) => {
      queryClient.invalidateQueries([VIDEO_COMPILATION]);
      useToast &&
        (navigationToast
          ? addSnackbarInfo({
              message: `Use the table below to select and deselect videos you'd like to include in your compilation. 
              Then hit Update Compilation to publish those changes!`,
              autoHideDuration: 15000
            })
          : addSnackbarSuccess({ message: 'Successfully Updated Video Compilation Page' }));
    }
  });
};

const postVideoCompilationPage = (payload) => api.post(`${VIDEO_COMPILATION}`, payload);

export const usePostVideoCompilationPage = () => {
  const { addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(postVideoCompilationPage, {
    onSuccess: () => {
      queryClient.invalidateQueries([VIDEO_COMPILATION]);
      addSnackbarSuccess({ message: 'Successfully Created Video Compilation Page' });
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useVideoCompilationData.js